<template>
    <div>
   
        <div class="drop_hint" @click="showModal">
            <div class="main_btn">
                <div class="d-flex align-items-center">
                    <SvgHeaderSvg :type="'ask'" />
                </div>
            </div>
        </div>
  

        <div v-if="flagShowModal">
            <Teleport  to="#teleports">
                <div class="modal fade" id="drophint" data-bs-backdrop="true" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="myModalRef">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-body">
                                    <div class="title_block">
                                        <div>
                                            <h5 class="modal-title font-active" id="exampleModalLabel">{{ item}}</h5>  
                                        </div>
                                        <span @click="hideModal"><SvgHeaderSvg type="close" class="largesvg"/></span>
                                    </div>
                                    
                                    <div class="slidemodal">
                                        <div v-if="item === 'Carat'">
                                            <p class="mb-0">Carats are units used to measure your diamond's weight.
                                                1-carat is equivalent to 200 milligrams or 0.2 grams. A diamond's size
                                                and carat weight are related; however, carats do not directly measure a
                                                diamond's size. With an increase in carat weight comes a price increase.
                                                <br><br>
                                                The below illustration shows the relationship between typical diamond
                                                sizes and their increasing carat weights. Please note that while the
                                                measurements below are standard, every diamond is unique.
                                            </p>
    

                                            <!-- <div class="image_block my-3">
                                                <img :src="currentCaratImage" width="115" height="220.5" alt="Current Cut Image" />
                                            </div> -->
                                            <br>
                                            <!-- <div id="carat-slider" ref="caratSlider" class="slider"></div> -->
                                            
                                            <div class="images" ref="scrollContainer">
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/0.5ct.png" alt="Current Carat Image">
                                                    <div class="ct">0.5ct</div>
                                                    <div>(5.1mm)</div>
                                                </div>
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/0.75ct.png" alt="Current Carat Image">
                                                    <div class="ct">0.75ct</div>
                                                    <div>(5.8mm)</div>
                                                </div>
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/1ct.png" alt="Current Carat Image">
                                                    <div class="ct">1ct</div>
                                                    <div>(6.4mm)</div>
                                                </div>
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/1.5ct.png" alt="Current Carat Image">
                                                    <div class="ct">1.5ct</div>
                                                    <div>(7.4mm)</div>
                                                </div>
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/2ct.png" alt="Current Carat Image">
                                                    <div class="ct">2ct</div>
                                                    <div>(8.1mm)</div>
                                                </div>
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/2.5ct.png" alt="Current Carat Image">
                                                    <div class="ct">2.5ct</div>
                                                    <div>(8.9mm)</div>
                                                </div>
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/3ct.png" alt="Current Carat Image">
                                                    <div class="ct">3ct</div>
                                                    <div>(9.3mm)</div>
                                                </div>
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/3.5ct.png" alt="Current Carat Image">
                                                    <div class="ct">3.5ct</div>
                                                    <div>(9.75mm)</div>
                                                </div>
                                                <div class="box text-center">
                                                    <img width="304" height="304" src="/loose_graphics/carat/4ct.png" alt="Current Carat Image">
                                                    <div class="ct">4ct</div>
                                                    <div>(10.1mm)</div>
                                                </div>
                                            </div>
                                            <p class="mb-0">
                                            <b>Pro tip :</b> Choose a diamond below the carat cutoffs (Choose a 0.90 carat instead of a 1.00 carat diamond) to save money on your purchase while not losing too much on the size of the diamond.</p>
                                        </div>

                                        <div v-if="item === 'Cut'">
                                            <p class="mb-0">A diamond’s cut determines its beauty and is related to its depth, width, and facet uniformity. A diamond’s ability to reflect and refract light is based on its cut.</p>
                                            <br>
                                            <div class="image_block">
                                                <img :src="currentCutImage" width="100" height="100" alt="Current Cut Image" />
                                            </div>
                                            <br>
                                            <div id="cut-slider" ref="cutSlider" class="slider" v-if="item === 'Cut'"></div><br><br>
                                            
                                            <p v-if="currentCutText" class="text_slide mb-0">{{ currentCutText }}</p>
                                        </div>
                                        
                                        <div v-if="item === 'Color'">
                                            <p class="mb-0">A diamond’s color grade measures the absence of color present in a diamond. Colorless diamonds let more light pass through than colored diamonds leading to more fire and sparkle.
                                            <br>
                                            <b>Pro tip :</b> Go for diamonds in the near colorless range (G-H-I) to get a beautiful diamond at a good price.</p>
                                            <div class="image_block">
                                                <img :src="currentColorImage" width="100" height="100" alt="Current Cut Image" />
                                            </div>
                                            <br>
                                            <div id="color-slider" ref="colorSlider" class="slider"></div>
                                            <br><br>
                                            
                                            <p v-if="currentColorText" class="text_slide mb-0">{{ currentColorText }}</p>

                                        </div>
                                                        
                                        <div v-if="item === 'Clarity'">
                                            <p class="mb-0">
                                                A diamond’s clarity measures the absence of impurities on and within a diamond. Impurities also known as flaws and inclusions occur during the diamond creation process. The lesser the flaws and inclusions the higher its value.
                                            </p>
                                            <div class="image_block">
                                                <img :src="currentClarityImage" width="100" height="100" alt="Current Cut Image" />
                                            </div>
                                            <br>
                                            <div id="clarity-slider" ref="claritySlider" class="slider"></div>
                                            <br><br>

                                            <p v-if="currentClarityText" class="text_slide mb-0">{{ currentClarityText }}</p>
                                            
                                        </div>
                                    </div>    

                                    <div v-if="item === 'Polish'">
                                        <p class="mb-0">Polish is related to the diamond’s facet finish. It assesses whether the facets have been smoothly polished and how defined are the edges of these facets. 
                                            A well-polished diamond (a good or higher polish grade) is a good quality diamond that reflects back maximum light and has excellent brilliance.
                                        </p>
                                    </div>

                                    <div v-if="item === 'Fluorescence'">
                                        <p class="mb-0">Fluorescence measures how a diamond emits light when exposed to ultraviolet light. Fluorescence does not visually impact the diamond’s appearance or compromise its structural integrity. A diamond with strong or very strong fluorescence may impact the flow of light and could make the diamond appear cloudy or milky.
                                            <br><br>
                                        <b>Pro tip :</b> Most lab diamonds usually have no fluorescence. Consider going for a stone with no fluorescence only as it will have negligible effect on the cost.
                                        </p>
                                    </div>

                                    <div v-if="item === 'Symmetry'">
                                        <p class="mb-0">Symmetry is related to how the diamond’s facets are aligned. 
                                            If the facets are not in alignment the diamond might reflect light poorly. A diamond with excellent symmetry emits the most sparkle.</p>
                                    </div>

                                    <div v-if="item === 'Depth %'">
                                        <p class="mb-0">Depth refers to a diamond's height measured from the culet to the table. The depth % is the diamond’s depth as a percentage of its girdle diameter. The depth % contributes to the diamond’s appearance, brilliance and fire.
                                            <br><br>
                                        <b>Pro tip :</b> For maximum sparkle, go for a diamond with a depth % between 54% to 66%.</p>
                                    </div>
                                    
                                    <div v-if="item === 'LW Ratio'">
                                        <div class="parent_text">
                                            <p>Length-to-Width Ratio measures how proportionate your diamond appears when viewed from the top. It compares the length of a diamond to its width to show how elongated a fancy-shaped diamond appears. <br><br> Ex. A cushion-cut diamond that measures 5.05 mm long by 5.00mm wide has a length-to-width ratio of 1.01 (5.05/5.00), and will appear perfectly square. <br><br>
                                            Length-to-width ratio is a matter of personal choice Some individuals may prefer a more elongated shape and while the others a more equally proportionate shape. The most popular length-to-width ratios for fancy shaped diamonds are listed below.</p>
                                            <p class="mb-1"><strong>Most popular length-to-width ratios:</strong></p>
                                            <ul class="ps-4">
                                                <li>Princess: 1.00-1.05</li> 
                                                <li>Radiant: 1.00-1.05</li> 
                                                <li>Asscher: 1.00-1.05</li> 
                                                <li>Cushion: 1.00-1.05</li> 
                                                <li>Heart: 0.90-1.10</li> 
                                                <li>Emerald: 1.30-1.40</li> 
                                                <li>Oval: 1.30-1.70</li> 
                                                <li>Pear: 1.45-1.75</li> 
                                                <li>Marquise: 1.75-2.30</li> 
                                            </ul>
                                        </div>
                                    </div>
                            
                                    <div v-if="item === 'Table %'">
                                        <p class="mb-0">
                                            The table is a diamond’s biggest facet that is located on the topmost part of the diamond. 
                                            This attribute measures the table’s width as a percentage of its girdle diameter. 
                                            A diamond with a table % in its right range will sparkle more.
                                        </p>
                                    </div>
                
                        </div>
                    </div>
                </div>
                </div>
            </Teleport>

        </div>
    </div>
</template>

<script setup>
    import noUiSlider from 'nouislider';

    const { item } = defineProps(['item'])
    import 'nouislider/dist/nouislider.css';
    const scrollContainer = ref('')
    const startX = ref(0);
    const isDown = ref(false)
    const scrollLeft = ref(0);
   
    const cutImages = [
        '/loose_graphics/newcut/fair.svg',
        '/loose_graphics/newcut/good.svg',
        '/loose_graphics/newcut/verygood.svg',
        '/loose_graphics/newcut/excellent.svg',
        '/loose_graphics/newcut/ideal.svg',
    ];
    const colorImages = [
        '/loose_graphics/color/m.svg',
        '/loose_graphics/color/l.svg',
        '/loose_graphics/color/k.svg',
        '/loose_graphics/color/j.svg',
        '/loose_graphics/color/i.svg',
        '/loose_graphics/color/h.svg',
        '/loose_graphics/color/g.svg',
        '/loose_graphics/color/f.svg',
        '/loose_graphics/color/e.svg',
        '/loose_graphics/color/d.svg',
    ];
    const clarityImages = [
        '/loose_graphics/clarity/si2.svg',
        '/loose_graphics/clarity/si1.svg',
        '/loose_graphics/clarity/vs2.svg',
        '/loose_graphics/clarity/vs1.svg',
        '/loose_graphics/clarity/vvs2.svg',
        '/loose_graphics/clarity/vvs1.svg',
        '/loose_graphics/clarity/if.svg',
        '/loose_graphics/clarity/fl.svg',
    ];
    // const caratImages = [
    //     '/loose_graphics/carat/0.5ct.png',
    //     '/loose_graphics/carat/0.75ct.png',
    //     '/loose_graphics/carat/1ct.png',
    //     '/loose_graphics/carat/1.5ct.png',
    //     '/loose_graphics/carat/2ct.png',
    //     '/loose_graphics/carat/2.5ct.png',
    //     '/loose_graphics/carat/3ct.png',
    //     '/loose_graphics/carat/3.5ct.png',
    //     '/loose_graphics/carat/4ct.png',
    // ];
    const cutTexts = [
    'A diamond of good quality that reflects light while increasing weight. This cut, however, does not have the brilliance of a good cut as it is affected by light that leaks past the pavilion.',
    'A diamond cut of superior quality to improve size without cutting on beauty and quality. A good cut reflects most of the light that enters the diamond.',
    'A very good cut that balances brilliance and size. It reflects most light well, offering both beauty and value.',
    'A diamond cut of superior quality that reflects nearly as much light as an excellent cut diamond but at a cost that is significantly lower.',
    'An exquisite cut that lends the diamond a great combination of fire and brilliance. An ideal diamond reflects almost all the light that enters the diamond.'
];
    const colorTexts = [
        //'M','L','K','J','I','H','G','F','E','D' 
    'A colored diamond with perfectly noticeable color to the naked eye.',
    'A faint colored diamond with noticeable color to the naked eye.',
    'A faint colored diamond with slightly noticeable color to the naked eye.',
    'A nearly colorless diamond with detected color.',
    'A good value, nearly colorless diamond with slightly detected color.',
    'An excellent value, nearly colorless diamond with slightly detected color in comparison to better graded diamonds.',
    'An excellent value, nearly colorless diamond with very slightly detected color in comparison to better graded diamonds.',
    'A high quality colorless diamond with slightly detected color under magnification.',
    'A rare, high quality colorless diamond with only minute color traces that are detected under magnification.',
    'An extremely rare and highest quality diamond that is absolutely colorless and icy white.',
    ];

    const clarityTexts = [
        // SI2, SI1, VS2, VS1, VVS2, VVS1, IF, FL,
        'A slightly included 2 (SI2) diamond has inclusions on and within the diamond that are visible under 10x magnification and might also be visible to the naked eye. SI2 diamonds have more inclusions than SI1 Diamonds.',
        'A slightly included 1 (SI1) diamond has inclusions that are visible under 10x magnification but might not be very visible to the naked eye.',
        'A very slightly included 2 (VS2) diamond has inclusions that are hard to see under 10x magnification. The flaws & inclusions are mostly not visible to the naked eye and have slightly more inclusions than VS1 diamonds.',
        'A very slightly included 1 (VS1) diamond has inclusions that are hard to see under 10x magnification. The flaws & inclusions are mostly not visible to the naked eye.',
        'A very very slightly included 2 (VVS2) diamond has inclusions that are very hard to see under 10x magnification and are not visible to the naked eye. They have slightly more inclusions than VVS1 diamonds.',
        'A very very slightly included 1 (VVS1) diamond has inclusions that are very hard to see under 10x magnification and are not visible to the naked eye.',
        'An Internally flawless (IF) diamond has almost no internal or external inclusions.',
        'A flawless diamond (FL) is an extremely rare and valuable diamond that has absolutely no internal and external inclusions or flaws.',
    ]

    const currentCutImage = ref(cutImages[0]);
    const currentCutText = ref(cutTexts[0]);
    const currentColorText = ref(colorTexts[0]);
    const currentClarityText = ref(clarityTexts[0]);
    const currentColorImage = ref(colorImages[0]);
    const currentClarityImage = ref(clarityImages[0]);
    // const currentCaratImage = ref(caratImages[0]);
   
    const colorSlider = ref(null);
    const caratSlider = ref(null);
    const claritySlider = ref(null);
    const cutSlider = ref(null);

    const flagShowModal = ref(false);
    const myModalRef = ref(null);

    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
            const modalElement = myModalRef.value;
            if (modalElement) {
                const modalInstance = new bootstrap.Modal(modalElement);
                modalInstance.show();
                initializeSliders();
                initHorizontalScroll();
            }
        });
    };

    const hideModal = () => {
        const modalElement = myModalRef.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        destroySlider(cutSlider);
        destroySlider(colorSlider);
        destroySlider(claritySlider);

        flagShowModal.value = false;
    };

    const createSlider = (element, options) => {
        if (element.value && element.value instanceof HTMLElement) {
            if (element.value.noUiSlider) {
            element.value.noUiSlider.destroy();
        }
            noUiSlider.create(element.value, options);
        }
    };

    const destroySlider = (element) => {
        if (element.value && element.value.noUiSlider) {
            element.value.noUiSlider.destroy();
        }
    };

    const initializeSliders = () => {
        if (item === 'Cut') {
            createSlider(cutSlider, sliderOptions(['Fair', 'Good', 'Very Good', 'Excellent', 'Ideal']));
            cutSlider.value.noUiSlider.on('update', (values, handle) => {
            const index = Math.round(values[handle]);
            if (index >= 0 && index < cutImages.length) {
                currentCutImage.value = cutImages[index];
                currentCutText.value = cutTexts[index];
            } else {
                console.error('Invalid index calculated:', index);
            }
            });
            currentCutImage.value = cutImages[0];
            currentCutText.value = cutTexts[0];
        } 
        if(item === 'Color'){
            createSlider(colorSlider, sliderOptions(['M', 'L', 'K', 'J', 'I', 'H', 'G', 'F', 'E', 'D']))
            colorSlider.value.noUiSlider.on('update', (values, handle) => {
            const index = Math.round(values[handle]);
            if (index >= 0 && index < colorImages.length) {
                currentColorImage.value = colorImages[index];
                currentColorText.value = colorTexts[index];
            } else {
                console.error('Invalid index calculated:', index);
            }
            });
            currentColorImage.value = colorImages[0]; 
            currentColorText.value = colorTexts[0];
        }
        if (item === 'Clarity') {
            createSlider(claritySlider, sliderOptions(['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF', 'FL']));
            claritySlider.value.noUiSlider.on('update', (values, handle) => {
            const index = Math.round(values[handle]);
            if (index >= 0 && index < clarityImages.length) {
                currentClarityImage.value = clarityImages[index];
                currentClarityText.value = clarityTexts[index];
            } else {
                console.error('Invalid index calculated:', index);
            }
           
            });
            currentClarityImage.value = clarityImages[0];
            currentClarityText.value = clarityTexts[0];
        }  
        // if (item === 'Carat') {
        //    createSlider(caratSlider, sliderOptions(['0.5', '0.75', '1', '1.5', '2', '2.5', '3', '3.5','4']));
        //     caratSlider.value.noUiSlider.on('update', (values, handle) => {
        //     const index = Math.round(values[handle]);
        //     if (index >= 0 && index < caratImages.length) {
        //         currentCaratImage.value = caratImages[index];
        //     } else {
        //         console.error('Invalid index calculated:', index);
        //     }
        //     });
        //     currentCaratImage.value = caratImages[0];   
        // } 
    };

    const sliderOptions = (labels) => ({
        start: [0],
        connect: [true, false],
        range: { min: 0, max: labels.length - 1 },
        step: 1,
        format: {
        to: (value) => Math.round(value),
        from: (value) => Math.round(value)
    },
        pips: {
            mode: 'positions',
            values: Array.from({ length: labels.length }, (_, i) => (i / (labels.length - 1)) * 100),
            density: 100,
            format: { to: value => labels[Math.round(value)] },
        },
    });

    function initHorizontalScroll() {
    if(scrollContainer.value){
        const scroll_Container = scrollContainer.value;

        scroll_Container.addEventListener('mousedown', (e) => {
            isDown.value = true;
            startX.value = e.pageX - scroll_Container.offsetLeft;
            scrollLeft.value = scroll_Container.scrollLeft;
        });

        scroll_Container.addEventListener('mouseleave', () => {
            isDown.value = false;
        });

        scroll_Container.addEventListener('mouseup', () => {
            isDown.value = false;
        });

        scroll_Container.addEventListener('mousemove', (e) => {
            if (!isDown.value) return;
            e.preventDefault();
            const x = e.pageX - scroll_Container.offsetLeft;
            const walk = (x - startX.value) * 3; // Adjust scrolling speed here
            scroll_Container.scrollLeft = scrollLeft.value - walk;
        });
    }
}

    watch(() => item, () => {
        // Destroy existing sliders to prevent overlapping instances
        destroySlider(colorSlider);
        destroySlider(caratSlider);
        destroySlider(claritySlider);
        destroySlider(cutSlider);

        // Re-initialize sliders based on the new item value
        if (flagShowModal.value) {
            initializeSliders();
        }
    });

    onBeforeUnmount(() => {
        destroySlider(colorSlider);
        // destroySlider(caratSlider);
        destroySlider(claritySlider);
        destroySlider(cutSlider);
    });

    onMounted(() => {
        initHorizontalScroll();   
    })
        
</script>

<style scoped>
.images {
    display: flex;
    overflow-x: auto; 
    gap: 16px;
    align-items: center;
    cursor: pointer;
    padding-bottom: 10px;
}

.images .box {
    flex: 0 0 auto; 
    width: 80px;
}

.box .ct {
    font-weight: 600;
}

.largesvg {
    transform: scale(1.3);
    }
    
 ul li {
    color: #6a6161;
    font-size: 16px;
}
p{
    font-size: 16px;
    padding-top: 9px;
    color: #606060;
}

.image_block{
    text-align: center;
}
.main_btn{
 cursor: pointer;
}
.title_block {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.title_block span {
    cursor: pointer;
}
.slider{
    margin: 0 8px 0 10px;
    }
.title_block h5 {
    font-size: 22px;
}

.slider {
    margin-top: 10px;
    border: 1px solid #ddd; 
    height: 10px;
}

/* -----scroll--------- */
/* width */
.images::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  
  /* Track */
  .images ::-webkit-scrollbar-track {
    background: #f5f5f5; 
  }
   
  /* Handle */
  .images::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    cursor: pointer;
  }
  
  /* Handle on hover */

  /* -----scroll--------- */

@media(max-width: 767px){
    p, ul li {
        font-size: 14px;
    }

    .title_block h5 {
        font-size: 20px;
    }
} 
</style>